(function () {
  // Only run on homepage
  if (!document.body.classList.contains('template-index')) return;

  const popupEl = document.getElementById('PSGiveawayPopup');
  if (!popupEl) return;

  const target = document.querySelector('.ps-membership-wrapper');
  if (!target) return;

  // Frequency control (once every N days)
  const days = parseInt(popupEl.dataset.frequencyDays || '7', 10);
  const key = 'ps_giveaway_popup_last_seen';

  // Test mode: add ?ps_giveaway_test=1 to force
  const params = new URLSearchParams(window.location.search);
  const force = params.get('ps_giveaway_test') === '1';

  if (!force) {
    const last = localStorage.getItem(key);
    if (last) {
      const diffDays = (Date.now() - parseInt(last, 10)) / (1000 * 60 * 60 * 24);
      if (diffDays < days) return;
    }
  }

  let scrollY = 0;

    function lockBodyScroll() {
    scrollY = window.scrollY || window.pageYOffset || 0;
    document.body.classList.add('ps-lock-scroll');
    document.body.style.top = `-${scrollY}px`;
    }

    function unlockBodyScroll() {
    document.body.classList.remove('ps-lock-scroll');
    const y = Math.abs(parseInt(document.body.style.top || '0', 10)) || 0;
    document.body.style.top = '';
    window.scrollTo(0, y);
    }

  // Impulse can apply modal-open to <body> or <html>
  const isAnyModalOpen = () =>
    document.documentElement.classList.contains('modal-open') ||
    document.body.classList.contains('modal-open') ||
    !!document.querySelector('.modal--is-active, .modal--open, .drawer--is-open');

  let opened = false;
  const modal = (window.theme && theme.Modals) ? new theme.Modals('PSGiveawayPopup', 'ps-giveaway') : null;

  const tryOpen = () => {
  if (opened) return true;
  if (isAnyModalOpen()) return false;

  if (modal && modal.open) {
    modal.open();
  } else {
    // Fallback: show the modal by class if theme.Modals isn't available
    popupEl.classList.add('modal--is-active');
  }

  // ALWAYS lock after opening (both branches)
  lockBodyScroll();

  opened = true;
  localStorage.setItem(key, String(Date.now()));
  return true;
};

  // Open when membership selector enters viewport.
  // If another popup is open, retry a few times instead of giving up.
  const openWhenPossible = () => {
    let attempts = 0;
    const tick = () => {
      attempts++;
      if (tryOpen()) return;
      if (attempts < 12) setTimeout(tick, 600);
    };
    tick();
  };

  const observer = new IntersectionObserver((entries) => {
    if (!entries[0].isIntersecting || opened) return;
    openWhenPossible();
    // don't disconnect until it actually opens
    const wait = setInterval(() => {
      if (opened) {
        clearInterval(wait);
        observer.disconnect();
      }
    }, 200);
  }, { root: null,
  rootMargin: "0px 0px -100px 0px", // 👈 triggers 200px before entering viewport
  threshold: 0 });

  observer.observe(target);

  // Unlock scrolling when popup is closed (X, backdrop, ESC, etc.)
    const unlockIfPopupClosed = () => {
    // If the popup is no longer active/open, unlock
    const isActive =
        popupEl.classList.contains('modal--is-active') ||
        popupEl.classList.contains('modal--open') ||
        popupEl.getAttribute('aria-hidden') === 'false';

    if (!isActive) unlockBodyScroll();
    };

    // Close button + backdrop clicks
    document.addEventListener('click', function (e) {
    const clickedClose =
        e.target.closest('#PSGiveawayPopup .js-modal-close') ||
        e.target.closest('#PSGiveawayPopup .modal__close') ||
        e.target.closest('#PSGiveawayPopup [data-close]') ||
        e.target.id === 'PSGiveawayPopup'; // sometimes overlay is the modal itself

    if (!clickedClose) return;

    // Let theme close first, then unlock
    setTimeout(unlockIfPopupClosed, 50);
    });

    // ESC key closes modal in many themes
    document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
        setTimeout(unlockIfPopupClosed, 50);
    }
    });

    // CTA: close popup + smooth scroll to membership selector
    document.addEventListener('click', function (e) {
    const cta = e.target.closest('#PSGiveawayPopup .ps-giveaway__cta');
    if (!cta) return;

    const href = cta.getAttribute('href') || '';
    if (!href.includes('#')) return;

    e.preventDefault();

    // Close modal
    const closeBtn = document.querySelector('#PSGiveawayPopup .js-modal-close');
    if (closeBtn) closeBtn.click();

    // Unlock scroll (your existing function)
    unlockBodyScroll();

    // Support both "#ps-memberships" and "/#ps-memberships"
    const anchor = href.split('#')[1];
    const dest = document.getElementById(anchor);
    if (!dest) return;

    // Wait a moment for Impulse close animation + scroll restore to finish
    setTimeout(() => {
        dest.scrollIntoView({ behavior: 'smooth', block: 'start' });

        dest.classList.add('ps-scroll-pulse');
        setTimeout(() => dest.classList.remove('ps-scroll-pulse'), 900);
    }, 250);
    });
})();